import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Flex, Select, Divider, Row, Col, Statistic, Modal, Descriptions, Tabs, Popconfirm, Dropdown } from 'antd';
import CustomerService from "services/customer"
import DebtService from "services/debt"
import { formatCurrency } from "utils/number"
import { formatDate, formatOnlyDate } from "utils/date"
import { useNavigate } from 'react-router';
import UpdateDebt from 'components/debt/Update';
import AddDebt from "components/debt/AddDebt"
import AddPayment from "components/debt/AddPayment"
import _ from "lodash"
import { useApp } from 'contexts/app';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import PaymentDetail from "components/debt/PaymentDetail"
const service = new CustomerService();
const debtService = new DebtService();

const { Search } = Input;
const DebtInfo = ({ customer, onChange }) => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);

    const [orders, setOrders] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [filter, setFilter] = useState({ info: "" })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [lstDebt, setLstBebt] = useState([])
    const [lstDebtFilled, setLstDebtFilled] = useState([])
    const [updateDebt, setUpdateDebt] = useState({})
    const [debtFilter, setDebtFilter] = useState({ type: "all", start: dayjs().add(-30, 'day') })
    const [debt, setDebt] = useState({ begin: 0, debt: 0, payment: 0, remain: 0 })


    const { printPdf, showLoading, downloadPDF, sharePDF, copyPDF } = useApp();



    useEffect(() => {
        loadDebt(customer.id);
    }, [debtFilter.start, customer.id])




    //filter lst debt
    useEffect(() => {
        switch (debtFilter.type) {
            case "has_remain_amount":
                var lst = lstDebt.filter(x => x.type == "debt" && x.remain_amount > 0)
                setLstDebtFilled(lst)
                break;
            case "debt":
                var lst = lstDebt.filter(x => x.type == "debt")
                setLstDebtFilled(lst)
                break;
            case "payment":
                var lst = lstDebt.filter(x => x.type == "payment")
                setLstDebtFilled(lst)
                break;
            case "all":

                setLstDebtFilled([...lstDebt])
                break;


            default:
                break;
        }

    }, [lstDebt, debtFilter])






    const showUpdateDebt = (debtId) => {
        setUpdateDebt({ isShow: true, id: debtId })
    }






    const loadDebt = async (id) => {

        var data = await service.getDebt(id, debtFilter.start);
        var debts  = _.orderBy(data.debts, ["date", "create_on"], ["desc", "desc"])
        setLstBebt(debts);
        setDebt(data);

    }






    const printDebt = async () => {
        showLoading(true);

        var data = await debtService.print(customer.id, debtFilter.start);
        showLoading(false);

        if (data) {
            downloadPDF(data.file, "CongNo.pdf")
            //window.open(data.file, "_blank") ;
        }

    }
    const deleteDebt = async debtID => {
        showLoading(true);
        await debtService.delete(debtID);
        showLoading(false);
        onChange();
    }

    const items = [
        {
            key: 'share_pdf',
            label: 'Share file',
        },
        {
            key: 'copy_pdf',
            label: 'Copy file',
        },

    ];


    const columns = [
        {
            title: 'Ngày',

            render: (record) => {

                return (
                    <Space direction='vertical'>

                        <div>
                            {record.type === "payment" ?
                                <Button type='link' onClick={e => showUpdateDebt(record.id)}>
                                    {formatOnlyDate(record.date)}
                                </Button>
                                :
                                <>
                                    <Button type='text' >
                                        {formatOnlyDate(record.date)}
                                    </Button>

                                </>


                            }


                        </div>
                    </Space>
                )

            }
        },


        {
            title: 'Nội dung',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        <div>
                            {record.type == "payment" &&
                                <>

                                </>
                            }
                            {record.description}
                        </div>

                    </Space>
                )


                return record.total_item
            }
        },
        {
            title: 'Số tiền',

            render: (record) => {

                return (
                    <Space direction='vertical'>

                        {formatCurrency(record.amount)}


                    </Space>
                )

            }
        },






    ];


    const onMenuClick = e => {
        console.log('click', e);
        shareDebtPDF();
        switch (e.key) {
            case "copy_pdf":
                copyDebtPDF()
                break;
            case "share_pdf":
                shareDebtPDF()
                break;

            default:
                break;
        }
    };

    const shareDebtPDF = async () => {
        showLoading(true);

        var data = await debtService.print(customer.id, debtFilter.start);
        showLoading(false);

        if (data) {
            sharePDF(data.file, "CongNo.pdf")
            //window.open(data.file, "_blank") ;
        }


    }

    const copyDebtPDF = async () => {
        showLoading(true);

        var data = await debtService.print(customer.id, debtFilter.start);
        showLoading(false);

        if (data) {
            copyPDF(data.file, "CongNo.pdf")

        }


    }





    return (
        <>

            <Space direction='vertical' style={{ width: "100%" }}>
                <Row>
                    <Col span={24}>
                        <Flex justify='flex-end'>
                            <div>
                                <label>Từ ngày: </label>
                                <DatePicker showNow={false} value={debtFilter.start} onChange={e => setDebtFilter({ ...debtFilter, start: e.startOf("day") })}
                                    presets={[
                                        { label: "Từ lần thanh toán gần đây", value: dayjs(customer.debt?.last_payment_date).startOf("day") },
                                        { label: "Từ ngày sạch nợ", value: dayjs(customer.debt?.zero_debt_date).startOf("day") },
                                        { label: "1 tháng trước", value: dayjs().add(-1, "month").startOf("day") },
                                        { label: "2 tháng trước", value: dayjs().add(-2, "month").startOf("day") },
                                        { label: "3 tháng trước", value: dayjs().add(-3, "month").startOf("day") },
                                    ]}
                                ></DatePicker>
                            </div>

                        </Flex>

                    </Col>
                    <Col span={6}>
                        <Statistic title="Đầu kỳ" value={formatCurrency(debt.begin)} />
                    </Col>
                    <Col span={6}>
                        <Statistic title="Mua mới" value={formatCurrency(debt.debt)} />
                    </Col>
                    <Col span={6}>
                        <Statistic title="Thanh toán" value={formatCurrency(debt.payment)} />
                    </Col>
                    <Col span={6}>
                        <Statistic title="Còn nợ" value={formatCurrency(debt.remain)} />
                    </Col>
                    {/* 
                    <Col span={6}>
                        <Button onClick={loadDebt}>Load</Button>
                    </Col> */}

                </Row>


                <Flex justify='flex-end' style={{ width: "100%" }}>
                    <Space>
                        <Space>

                            <Select style={{ width: 150 }} value={debtFilter.type} onChange={e => setDebtFilter({ ...debtFilter, type: e })} options={[{ value: 'debt', label: "Ghi nợ" }, { value: 'payment', label: "Thanh toán" }, { value: 'all', label: "Tất cả" }]} />

                        </Space>
                        <AddPayment onSaved={onChange} customer_id={customer.id}></AddPayment>
                        <AddDebt onSaved={onChange} customer_id={customer.id}></AddDebt>
                        <Dropdown.Button onClick={printDebt} type='primary' menu={{ items, onClick: onMenuClick }}>Tải xuống PDF</Dropdown.Button>

                    </Space>
                </Flex>
                <Table dataSource={lstDebtFilled} columns={columns} scroll={{ y: 300 }} />

            </Space>
            <PaymentDetail onSaved={onChange} open={updateDebt.isShow} id={updateDebt.id} onClose={open => setUpdateDebt({ ...updateDebt, isShow: false })}></PaymentDetail>




        </>

    )
}

export default DebtInfo;
